module.exports = __webpack_public_path__ + "img/logo_v2.0.c2e2bd9e.png";